// tipAnalytics — 「困りごとのコツ」カードの表示・操作の計装
// (docs/_wip/aa-default-and-trouble-tips-2026-10-27.md §2 記録)。
//
// `analytics.tip { tipId, action }` を fire-and-forget で送る。`inviteAnalytics` /
// `layoutSwitchAnalytics` と同じく Transport port のみに依存し、送信失敗は握りつぶす。

import type { TipAction, TroubleTipId } from '@oekaki/protocol';
import type { Transport } from './ports/Transport.js';

export const reportTip = (transport: Transport, tipId: TroubleTipId, action: TipAction): void => {
  // socket が open でなければ server が部屋を特定できないので黙って捨てる。
  if (transport.status.t !== 'open') return;
  try {
    transport.send({ t: 'analytics.tip', tipId, action });
  } catch {
    // best-effort
  }
};
